export default __webpack_public_path__ + "7b3ad59adfdb24e76e76364a32eeabf0.png";